/* eslint-disable import/prefer-default-export */
import {
  useQuery,
} from '@tanstack/react-query';
import {
  getStats,
  getStatsAnalyse,
  getStatsInscriptions,
  getStatsList,
  getStatsSalon,
} from '~/api/stats';
import {
  ArgsGetStats,
  ArgsGetStatsV2,
  StatsAnalyse,
  StatsInscriptions,
  StatsSalon,
} from '~/types/stats';

function useGetStats(params: ArgsGetStats) {
  return useQuery({
    queryKey: ['statistiques', params],
    queryFn: () => getStats(params),
    keepPreviousData: true,
    refetchInterval: 300000, // Refetch every minute
  });
}

const useGetStatsList = () => useQuery({
  queryKey: ['statistiques-list'],
  queryFn: () => getStatsList(),
});

function useGetStatsInscriptions(params: ArgsGetStatsV2) {
  return useQuery<StatsInscriptions | null>({
    queryKey: ['statistiques', 'inscriptions', params],
    queryFn: () => getStatsInscriptions(params),
    keepPreviousData: true,
    refetchInterval: 300000,
  });
}

function useGetStatsSalon(params: ArgsGetStatsV2) {
  return useQuery<StatsSalon | null>({
    queryKey: ['statistiques', 'salon', params],
    queryFn: () => getStatsSalon(params),
    keepPreviousData: true,
    refetchInterval: 300000,
  });
}

function useGetStatsAnalyse(params: ArgsGetStatsV2) {
  return useQuery<StatsAnalyse | null>({
    queryKey: ['statistiques', 'analyse', params],
    queryFn: () => getStatsAnalyse(params),
    keepPreviousData: true,
    refetchInterval: 300000,
  });
}

export {
  useGetStatsList,
  useGetStats,
  useGetStatsInscriptions,
  useGetStatsSalon,
  useGetStatsAnalyse,
};
